import { items } from "@api/stores/purchaseInvoices/returns/items/api";
import { reclaim } from "@api/stores/purchaseInvoices/returns/reclaim/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type {
  IPurchaseInvoicesReturnsDto,
  IPurchaseInvoicesReturnsResponse,
} from "@api/stores/purchaseInvoices/returns/types";

import type { IPathBaseParam, IPathByIdParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoicesReturnsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.purchaseInvoices.returns");
const postApis = createPostApi<
  IApiResponse<IPurchaseInvoicesReturnsResponse>,
  IPathBaseParam,
  IPurchaseInvoicesReturnsDto
>("stores.purchaseInvoices.returns");
const getApis = createGetApi<
  IApiResponse<IPurchaseInvoicesReturnsResponse>,
  IPathByIdParam,
  object
>("stores.purchaseInvoices.returns");

export const returns = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  reclaim,
  items,
};
